import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import isEmpty from 'app/utils/IsEmpty';

import { fetchComplianceAdvance, programingSendEmail } from 'app/actions/CommunicationActions';
import { getComplianceAdvance, getIsLoadingComplianceAdvance } from 'app/reducers';
import { IconButton } from '@material-ui/core';
import { Icon, Tooltip } from 'antd';

export default function CommunicationProgramManagementContainer(props) {
    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;
    let defaultData = {}

    const {
        Roles
    } = useSelector(state => state.Auth.item.User);

    const IsSuperAdmin = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Super Administrador')) {
                return true;
            }

        }
        return null;
    }

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'employeeName',
            key: 'employeeName',
            sorter: true,
            width: 350,
            ellipsis: true
        },
        {
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            sorter: true,
            width: 200,
            ellipsis: true

        },
        {
            title: 'Subdirección',
            dataIndex: 'subdirectionName',
            key: 'subdirectionName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {
            title: 'Folio Programa de Comunicación',
            dataIndex: 'communicationFolio',
            key: 'communicationFolio',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {
            title: 'Fecha de Creación',
            dataIndex: 'creationDate',
            key: 'creationDate',
            sorter: true,
            width: 200,
            render: (creationDate) => {
                return moment(creationDate).locale('es').format('L')
            }
        },
        {
            title: 'Fecha de Aprobación',
            dataIndex: 'approvalDate',
            key: 'approvalDate',
            sorter: true,
            width: 200,
            render: (approvalDate) => {
                if (approvalDate === '---')
                    return approvalDate;
                else
                    return moment(approvalDate).locale('es').format('L')
            }
        },
        {
            title: 'Estatus',
            dataIndex: 'communicationStatus',
            key: 'communicationStatus',
            sorter: true,
            width: 200
        },
        {
            width: '100%'
        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'employeeId',
            fixed: 'right',
            render: (text, record) => (
                <div className={props.classes.buttons}>
                    <Tooltip placement="bottom" title={'Notificar'}>
                        <IconButton disabled={record.idCommunicationStatus !== 1} className={props.classes.deleteIcon} onClick={() => NotifyEmployee(record)}>
                            <Icon type="notification" />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
        /*{
            title: 'Fecha de programación',
            dataIndex: 'dateProgram',
            key: 'dateProgram',
            sorter: true,
            width: 200,
            render: (dateProgram) => {
                return moment(dateProgram).locale('es').format('L')
            }
        },
        {
            title: 'Fecha CT',
            dataIndex: 'dateEvaluatorEvaluation	',
            key: 'dateEvaluatorEvaluation	',
            sorter: true,
            width: 200,
            render: (dateEvaluatorEvaluation) => {
                return moment(dateEvaluatorEvaluation).locale('es').format('L')
            }
        },*/

    ];

    const NotifyEmployee = (data) => {
        dispatch(programingSendEmail(data.idDiffusionCourse, data.employeeId));
    }


    let complianceAdvance = useSelector(getComplianceAdvance);

    let isLoading = useSelector(getIsLoadingComplianceAdvance);
    const dispatch = useDispatch();

    useEffect(() => {
        /*if (isEmpty(complianceAdvance))*/ fetchComplianceAdvanceAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }
        var respnse = IsSuperAdmin();
        dispatch(fetchComplianceAdvance(
            {
                idCategory: props.idCategory,
                idCommunicationProgram: props.idCommunicationProgram,
                idContract: props.idContract,
                idSpecialty: props.idSpecialty === null ? '' : props.idSpecialty,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
                , EsSuperAdmin: respnse ? 1 : 0
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && complianceAdvance.length > 0) {
            pagination.total = complianceAdvance[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }

    const fetchComplianceAdvanceAction = () => {
        var respnse = IsSuperAdmin();
        dispatch(fetchComplianceAdvance({
            idCategory: props.idCategory,
            idCommunicationProgram: props.idCommunicationProgram,
            idContract: props.idContract,
            idSpecialty: props.idSpecialty === null ? '' : props.idSpecialty,
            idCourse: props.idCourse,
            sortColumn: column,
            sortDir: order, offset: offset, limit: limit
            , EsSuperAdmin: respnse ? 1 : 0
        }));
    }


    if (isEmpty(complianceAdvance) === false) defaultData = complianceAdvance[0].data;
    return (props.children({ pagination: pagination, cols: columns, complianceAdvance, defaultData, isLoading, handleTableChange: handleTableChange }));
}


